import PipelineStateIcon, {
  colorForJob,
} from "app/components/shared/PipelineStateIcon/PipelineStateIcon";
import { Job } from "app/stores/BuildShowStore";
import classNames from "classnames";

export function State({ job }: { job: Job }) {
  return (
    <PipelineStateIcon
      job={job}
      className={classNames("w-4 h-4 block", colorForJob(job))}
      style={{ width: undefined, height: undefined }}
    />
  );
}
